import React from "react";
import ShelfLabelApp from "./ShelflabelApp";


function App() {
  return <ShelfLabelApp />;
}
export default App;
